export const isDeleteKeyboardEvent = (keyboardEvent: KeyboardEvent) => {
  return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete'
}

export const subscribeEvent = (
  event: string,
  callback: (event: CustomEvent) => void,
) => {
  document.addEventListener(event, callback as EventListener)
}

export const unsubscribeEvent = (
  event: string,
  callback: (event: CustomEvent) => void,
) => {
  document.removeEventListener(event, callback as EventListener)
}

export const fireEvent = (eventName: string, init: CustomEventInit) => {
  const event = new CustomEvent(eventName, init)
  document.dispatchEvent(event)
}
